import * as ambassadorWixEcomV1LocalDeliveryOption from './ecom-v1-local-delivery-option-local-delivery-options.http.js';
import * as ambassadorWixEcomV1LocalDeliveryOptionTypes from './ecom-v1-local-delivery-option-local-delivery-options.types.js';
import * as ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createLocalDeliveryOption(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.CreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.CreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.CreateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.CreateLocalDeliveryOptionResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.CreateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.CreateLocalDeliveryOptionResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.createLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLocalDeliveryOption(): __PublicMethodMetaInfo<
  'GET',
  { localDeliveryOptionId: string },
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.GetLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.GetLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.GetLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.GetLocalDeliveryOptionResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.GetLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.GetLocalDeliveryOptionResponseNonNullableFields
> {
  const payload = { localDeliveryOptionId: ':localDeliveryOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.getLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/local-delivery-options/{localDeliveryOptionId}',
    pathParams: { localDeliveryOptionId: 'localDeliveryOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listLocalDeliveryOptions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.ListLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.ListLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.ListLocalDeliveryOptionsResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.ListLocalDeliveryOptionsResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.ListLocalDeliveryOptionsResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.ListLocalDeliveryOptionsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.listLocalDeliveryOptions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/localDeliveryOptions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLocalDeliveryOptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.QueryLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.QueryLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.QueryLocalDeliveryOptionsResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.QueryLocalDeliveryOptionsResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.QueryLocalDeliveryOptionsResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.QueryLocalDeliveryOptionsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.queryLocalDeliveryOptions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLocalDeliveryOption(): __PublicMethodMetaInfo<
  'PATCH',
  { localDeliveryOptionId: string },
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.UpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.UpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.UpdateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.UpdateLocalDeliveryOptionResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.UpdateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.UpdateLocalDeliveryOptionResponseNonNullableFields
> {
  const payload = {
    localDeliveryOption: { id: ':localDeliveryOptionId' },
  } as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.updateLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/local-delivery-options/{localDeliveryOption.id}',
    pathParams: { localDeliveryOptionId: 'localDeliveryOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteLocalDeliveryOption(): __PublicMethodMetaInfo<
  'DELETE',
  { localDeliveryOptionId: string },
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.DeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.DeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.DeleteLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.DeleteLocalDeliveryOptionResponse
> {
  const payload = { localDeliveryOptionId: ':localDeliveryOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.deleteLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/local-delivery-options/{localDeliveryOptionId}',
    pathParams: { localDeliveryOptionId: 'localDeliveryOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateLocalDeliveryOption(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkCreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkCreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkCreateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkCreateLocalDeliveryOptionResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkCreateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkCreateLocalDeliveryOptionResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.bulkCreateLocalDeliveryOption(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/local-delivery-options/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateLocalDeliveryOption(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkUpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkUpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkUpdateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkUpdateLocalDeliveryOptionResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkUpdateLocalDeliveryOptionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkUpdateLocalDeliveryOptionResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.bulkUpdateLocalDeliveryOption(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/bulk/local-delivery-options/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteLocalDeliveryOption(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkDeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkDeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkDeleteLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkDeleteLocalDeliveryOptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.bulkDeleteLocalDeliveryOption(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/local-delivery-options/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.AddDeliveryRegionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.AddDeliveryRegionResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.AddDeliveryRegionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.AddDeliveryRegionResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.addDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options/add-delivery-region',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.RemoveDeliveryRegionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.RemoveDeliveryRegionResponseNonNullableFields,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.RemoveDeliveryRegionResponse &
    ambassadorWixEcomV1LocalDeliveryOptionTypes.RemoveDeliveryRegionResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.removeDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options/remove-delivery-region',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
